import { render, staticRenderFns } from "./ShowQuestionGroups.vue?vue&type=template&id=9ec4f5ae&"
import script from "./ShowQuestionGroups.vue?vue&type=script&lang=js&"
export * from "./ShowQuestionGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports